import { Routes } from '@angular/router';

import { CategoryComponent } from './category.component';

export const routes: Routes = [
  {
    path: '',
    component: CategoryComponent,
    children: [
      {
        path: ':slug',
        loadComponent: () => import('../product-info/product-info.component')
      },
    ]
  },
]
